/**
 * RAG-30 — Correspondance entre une catégorie d'une source externe (chemin Interactiv
 * ou code Socoda) et une catégorie Ragues.
 */
export class CategoryMapping {
  id: number;
  source: string;
  external_code: string | null;
  external_path: string | null;
  category_id: string | null;
  category: { id: string; name: string } | null;
  origin: string;
  author: { id: number; email: string } | null;
  products_count: number;
  updated_at: string | null;

  constructor(data: any) {
    this.id = data.id;
    this.source = data.source;
    this.external_code = data.external_code ?? null;
    this.external_path = data.external_path ?? null;
    this.category_id = data.category_id ?? null;
    this.category = data.category ?? null;
    this.origin = data.origin;
    this.author = data.author ?? null;
    this.products_count = data.products_count ?? 0;
    this.updated_at = data.updated_at ?? null;
  }

  /** Valeur externe lisible : le chemin de libellés, sinon le code. */
  get externalLabel(): string {
    return this.external_path ?? this.external_code ?? "—";
  }

  /** Catégorie créée automatiquement par l'import Interactiv (candidate à la fusion). */
  get isAutoCreatedCategory(): boolean {
    return !!this.category_id && this.category_id.startsWith("IT_");
  }
}
